import { render, staticRenderFns } from "./keep_on_record.vue?vue&type=template&id=672e2ef8&scoped=true"
import script from "./keep_on_record.vue?vue&type=script&lang=ts"
export * from "./keep_on_record.vue?vue&type=script&lang=ts"
import style0 from "./keep_on_record.vue?vue&type=style&index=0&id=672e2ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e2ef8",
  null
  
)

export default component.exports